import Vue from 'vue'
import NumberHelpers from '../helpers/NumberHelpers'
import ContactHelpers from '../helpers/ContactHelpers'
import LookupData from '../helpers/LookupData'
import StringHelpers from '../helpers/StringHelpers'
import ArrayHelpers from '../helpers/ArrayHelpers'
import Firestore from '../data/Firestore'
import Utilities from './Utilities'


export default class {

    static groups = [
        {name: 'Clients', colour:'#31B404', members:983},
        {name: 'First Home Buyers', members: 14},
        {name: 'Investors', colour: '#FE2E9A', members: 87},
        {name: 'Marketing #4', colour:'#31B404', members:44},
        {name: 'Builders', members: 13, colour: '#AC58FA'},
        {name: 'Agents', colour: '#0080FF', members: 20},
    ]

    static randomInt(digits) {
        let str = ''
        for(var n = 0; n < digits; n++) {
            str += NumberHelpers.randomInt(9).toString()
        }
        return str
    } 

    static fakeContacts(count) {
        
        let contacts = []

        for(let n = 0; n < count; n++) {
            let contact = {
                _id: Firestore.getId(),
                image: Vue.faker().image.avatar(),
                firstName: Vue.faker().name.firstName(),
                lastName: Vue.faker().name.lastName(),
                mobile: this.randomMobile(),
                tags: {},
            }

            contact.email = this.fakeEmail(contact.firstName, contact.lastName)
            
            contacts.push(contact)
        }
        return contacts
    }

    static fakeGroups(contacts) {
        //Injects Groups (mutates)
        contacts.forEach(contact => {    
            for( let p = 0; p < NumberHelpers.randomInt(4); p++) {
                const group = StringHelpers.toCamelCase(ArrayHelpers.randomFromArray(this.groups).name)
                contact.tags[group] = true
            }
        })
    }

    static fakeRelationships(contacts) {

        const relationships = []
           
        contacts.forEach(contact => {

            //Partner
            const hasPartner = (NumberHelpers.randomInt(5) == 1)

            if(hasPartner) {
                const availableContacts = contacts.filter(contact => !contact.hasPartner)
                const partner = ArrayHelpers.randomFromArray(availableContacts)

                ContactHelpers.relateContacts(contact, 'Partner', partner, 'Partner', relationships)
            }

            const relationshipNames = LookupData.relationships().filter(o => o.text != 'Partner')

            //Other relationships...
            if(contacts.length > 5) {
                for(var p = 1; p < NumberHelpers.randomInt(2); p++) {
                    const related = ArrayHelpers.randomFromArray(contacts)
                    const relation = ArrayHelpers.randomFromArray(relationshipNames)
                    ContactHelpers.relateContacts(contact, relation.text, related, relation.relatedText, relationships)
                }
            }

        })

        return relationships
    }

    static randomMobile() {
        return '04' + this.randomInt(2) + ' ' + this.randomInt(3) + ' ' + this.randomInt(3)
    }

    static fakeEmail(firstName, lastName) {
        const domains = ['gmail.com', 'yahoo.com', 'hotmail.com', 'bigpond.net.au', 'outlook.com']
        const domain = ArrayHelpers.randomFromArray(domains)
        const joinString = ArrayHelpers.randomFromArray(['', '_', '.', '', '.'])
        const r1 = NumberHelpers.randomInt(3)
        const r2 = NumberHelpers.randomInt(3)

        const n1 = (r1 < 3 ? firstName : firstName[0]).toLowerCase()
        const n2 = (r2 < 3 ? lastName : lastName[0]).toLowerCase()

        return n1 + joinString + n2 + '@' + domain
    }

}


// WEBPACK FOOTER //
// ./src/helpers/FakeHelpers.js